import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipantNoteLabel } from '../mutations/createParticipantNoteLabel.mutation';
import type {
  CreateParticipantNoteLabelMutation,
  CreateParticipantNoteLabelMutationVariables,
} from '../types';

export const useCreateParticipantNoteLabelMutation = (
  options?: MutationOptions<
    CreateParticipantNoteLabelMutation,
    CreateParticipantNoteLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantNoteLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
